module.exports = __webpack_public_path__ + "img/stand_boluo_2_cut.67b9e276.png";